export default __webpack_public_path__ + "static/media/poleungkuk.1895e929.png";